import { BaseCarouselTracking } from './BaseCarouselTracking';

export class ListCarouselTracking extends BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        super(aalink, fathom, elem, num, link);
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    parse() {
        let isMovie = this.fathom.includes('movie');
        let movieGenre = this.link.getAttribute('data-genre');
        let sectionContainer = this.link.closest('section');
        let _carouselId = sectionContainer.getAttribute('data-carouselid');
        let _carouselContentType = isMovie ? 'movie' : 'show';
        _carouselContentType = this.fathom.includes('brand') ? 'brand' : _carouselContentType;
        let _carouselModel = sectionContainer.getAttribute('data-model');
        let _movieTitle = this.aalink[4].split('-').join(' ');
        _movieTitle = _movieTitle.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        
        return {
            pageType: 'front_door',
            carouselId: _carouselId,
            carouselContentType: _carouselContentType,
            carouselModel: _carouselModel,
            carouselLink: this.url,
            regionalCode: this.aalink[0].toString(),
            rowHeaderTitle: super.getCleanTitle(),
            posColNum: Number(this.aalink[3]).toString(),
            posRowNum: super.getPosRowNum(),
            showSeriesId: !isMovie ? this.link.getAttribute('id') : '',
            showTitle: !isMovie ? this.aalink[4] : '',
            showSeriesTitle: !isMovie ? this.aalink[4] : '',
            movieId: isMovie ? this.link.getAttribute('id') : '',
            movieTitle: isMovie ? _movieTitle : '',
            contentBrand: this.aalink[10] ?? 'na',
            contentLocked: this.aalink[23] ? this.aalink[23] : '',
            movieGenre
        };
    }
}
